var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Repley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-repley",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M11,20,1,12,11,4V9A10,10,0,0,1,21,19c0,.273-.01.543-.032.81A9,9,0,0,0,13.313,15L13,15H11ZM9,13h4.034l.347.007a10.973,10.973,0,0,1,3.676.766A7.984,7.984,0,0,0,11,11H9V8.161L4.2,12,9,15.839Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Repley);
export default __webpack_public_path__ + "static/media/icon-24-repley.297195a6407ddc674a84c44111a49395.svg";
export { ForwardRef as ReactComponent };